import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=6ec4654f&scoped=true&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"
import style0 from "./platform.vue?vue&type=style&index=0&id=6ec4654f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4654f",
  null
  
)

export default component.exports